<template>
  <div class="min-vh">
    <div class="p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">CUSTOMER DETAILS</h1>
    </div>
    <div class="mt-3 bg-white-border p-3 main-theme">
      <b-row class="mb-4">
        <b-col md="3" class="text-center">
          <b-img
            v-if="profile.imageUrl"
            :src="profile.imageUrl"
            class="img-customer"
            blank-color="#8a93a2"
            center
            rounded="circle"
            @error="replaceByDefault"
          />
          <b-avatar
            v-else
            size="150px"
          ></b-avatar>
        </b-col>
        <b-col md="9">
          <p class="txt-title">
            First Name: <span>{{ profile.firstName }} </span>
          </p>
          <p class="txt-title">
            Last Name: <span>{{ profile.lastName }} </span>
          </p>
          <p class="txt-title">
            Email: <span>{{ profile.email }} </span>
          </p>
          <p class="txt-title mb-0">
            Registed Date:
            <span>
              {{ new Date(profile.registedDateTime) | moment($formatDateTime) }}
            </span>
          </p>
        </b-col>
      </b-row>
      <b-tabs content-class="m-0 border p-3" v-model="tabIndex">
        <b-tab title="Custom Field">
          <TableList
            ref="customFieldList"
            title="EDIT CUSTOM FIELD"
            type="CustomField"
            :userGUID="userGUID"
            @reloadData="reloadData"
          />
        </b-tab>
        <b-tab title="System Field">
          <TableList
            ref="systemFieldList"
            title="EDIT SYSTEM FIELD"
            type="SystemField"
            :userGUID="userGUID"
            @reloadData="reloadData"
          />
        </b-tab>
      </b-tabs>
      <b-row class="mt-3">
        <b-col class="text-sm-left">
          <router-link to="/customer">
            <b-button class="btn-cancel tn-details-set text-uppercase px-5"
              >CANCEL</b-button
            >
          </router-link>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import defaultImg from '@/assets/images/icons/blank.png'
import TableList from "./components/TableList.vue";
export default {
  name: "CustomerDetails",
  components: {
    TableList,
  },
  data: function() {
    return {
      userGUID: this.$route.params.id,
      search: "",
      profile: {
        firstName: "",
        lastName: "",
        email: "",
        registedDateTime: null,
        lastUpdatedDateTime: null,
        userGUID: "",
        imageUrl: "",
      },
      modalMessage: "",
      tabIndex: 0,
    };
  },
  created: async function() {
    await this.getProfile();
  },
  methods: {
    replaceByDefault(e) {
      e.target.src = defaultImg
    },
    getProfile: async function() {
      this.isBusy = true;
      let body = {
        userGUID: this.userGUID
      }
      await this.axios
        .post(`${this.$baseUrl}/Customer/Detail`, body)
        .then((data) => {
          if (data.result == 1) {
            this.profile = data.detail;
          } else this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {isShow: true, msg : data.message});
        })
      this.isBusy = false;
    },
    async reloadData() {
      if(this.tabIndex === 1) this.getProfile();
    },
  },
};
</script>

<style lang="scss" scoped>
.img-customer,
.b-avatar {
  width: 150px !important;
  height: 150px !important;
}
</style>
